import { render } from "./ReportCenter.vue?vue&type=template&id=21887502&scoped=true&ts=true"
import script from "./ReportCenter.ts?vue&type=script&lang=ts&external"
export * from "./ReportCenter.ts?vue&type=script&lang=ts&external"

import "./ReportCenter.scss?vue&type=style&index=0&id=21887502&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21887502"]])

export default __exports__